import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function HoursSection() {
  const schedule = [{
    day: 'Lunes',
    hours: '10:00 – 20:00'
  }, {
    day: 'Martes',
    hours: '10:00 – 20:00'
  }, {
    day: 'Miércoles',
    hours: '10:00 – 20:00'
  }, {
    day: 'Jueves',
    hours: '10:00 – 20:00'
  }, {
    day: 'Viernes',
    hours: '10:00 – 20:00'
  }, {
    day: 'Sábado',
    hours: '10:00 – 20:00'
  }, {
    day: 'Domingo',
    hours: '09:00 – 14:00'
  }];
  // Get current day index (0 = Sunday, 1 = Monday, etc.)
  const currentDayIndex = new Date().getDay();
  // Map JS day index to our schedule array index (where Monday is 0)
  const scheduleIndex = currentDayIndex === 0 ? 6 : currentDayIndex - 1;
  return <section id="horarios" className="py-24 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-191">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-dark-card border border-white/5 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-192">
        {/* Decorative background glow */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-193" />

        <div className="flex items-center gap-4 mb-10 relative z-10" data-id="element-194">
          <div className="bg-gold/10 p-3 rounded-xl text-gold" data-id="element-195">
            <Clock size={28} data-id="element-196" />
          </div>
          <h2 className="text-3xl font-bold text-white" data-id="element-197">
            Horarios de atención
          </h2>
        </div>

        <div className="space-y-1 relative z-10" data-id="element-198">
          {schedule.map((item, index) => {
          const isToday = index === scheduleIndex;
          return <div key={item.day} className={`flex justify-between items-center py-4 px-4 rounded-xl transition-colors ${isToday ? 'bg-gold/10 border border-gold/20' : 'hover:bg-white/5 border border-transparent'}`} data-id="element-199">
                <div className="flex items-center gap-3" data-id="element-200">
                  <span className={`font-medium ${isToday ? 'text-gold' : 'text-gray-300'}`} data-id="element-201">
                    {item.day}
                  </span>
                  {isToday && <span className="text-[10px] uppercase tracking-wider bg-gold text-dark font-bold px-2 py-0.5 rounded-full" data-id="element-202">
                      Hoy
                    </span>}
                </div>
                <span className={`font-mono ${isToday ? 'text-white font-bold' : 'text-gray-400'}`} data-id="element-203">
                  {item.hours}
                </span>
              </div>;
        })}
        </div>
      </motion.div>
    </section>;
}